import { IconListType, IFormContent } from '@reapitform/common-ui'
import {
  FormIcon,
  Card,
  CardBodyAdditionalContent,
  CardBodyContent,
  CardBodySectionWrapper,
  CardBodyTitle,
  CardBodyWrapper,
  CardHeader,
} from '@reapitform/common-ui'

import { RenderFormContent } from './render-form-content'
import React from 'react'

export interface IFormContentCardProps {
  iconName?: IconListType
  headingText?: string
  bodyTitle?: IFormContent[]
  bodyContent?: IFormContent[]
  bodyAdditionalContent?: IFormContent[]
  cardId: string
}

export const FormContentCard: React.FC<IFormContentCardProps> = ({
  iconName,
  bodyTitle,
  headingText,
  bodyContent,
  bodyAdditionalContent,
  cardId,
}) => {
  return (
    <Card>
      {(iconName || headingText) && (
        <CardHeader Icon={<FormIcon iconName={iconName} />} title={headingText} data-testid="card-header" />
      )}
      <CardBodyWrapper>
        {!!bodyTitle?.length && (
          <CardBodySectionWrapper data-testid="card-body-title">
            {bodyTitle.map((content, index) => (
              <RenderFormContent
                key={index}
                index={index}
                StringContainer={CardBodyTitle}
                content={content}
                cardId={cardId}
              />
            ))}
          </CardBodySectionWrapper>
        )}
        {!!bodyContent?.length && (
          <CardBodySectionWrapper data-testid="card-body-content">
            {bodyContent?.map((content, index) => (
              <RenderFormContent
                key={index}
                index={index}
                StringContainer={CardBodyContent}
                content={content}
                cardId={cardId}
              />
            ))}
          </CardBodySectionWrapper>
        )}
        {!!bodyAdditionalContent?.length && (
          <CardBodySectionWrapper data-testid="card-body-additional">
            {bodyAdditionalContent?.map((content, index) => (
              <RenderFormContent
                key={index}
                index={index}
                StringContainer={CardBodyAdditionalContent}
                content={content}
                cardId={cardId}
              />
            ))}
          </CardBodySectionWrapper>
        )}
      </CardBodyWrapper>
    </Card>
  )
}
